import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/site";
import { useSEO } from "../lib/seo";
import SafeImage from "../components/SafeImage";

export default function ProductsIndex() {
    useSEO({
        title: "Products — Indian Spices & Agro Commodities | RP Traders",
        description:
            "Browse RP Traders' export-quality Indian spices: red chilli, Guntur Teja chilli, turmeric fingers & powder, coriander, cumin and the wider Indian spices range. Bulk supply to UAE, EU, USA and Asia.",
        keywords:
            "Indian spices product range, red chilli exporter, Guntur Teja, turmeric exporter, coriander exporter, cumin exporter, agro commodities",
    });
    return (
        <main className="bg-white pt-32 pb-24 sm:pt-40 sm:pb-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                    Product Range
                </span>
                <h1 className="mt-3 font-display text-4xl font-bold tracking-[-0.025em] sm:text-6xl">
                    Indian Spices &amp; Agro Commodities.
                </h1>
                <p className="mt-5 max-w-2xl text-ink-muted">
                    Every line is sourced direct, lab-tested and packed in food-safe facilities —
                    shipped under our IEC, FSSAI and Spices Board export registrations.
                </p>

                <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {PRODUCTS.map((p) => (
                        <Link
                            key={p.id}
                            to={`/products/${p.slug}`}
                            data-testid={`pi-card-${p.id}`}
                            className="group flex flex-col overflow-hidden rounded-3xl border border-hairline bg-white transition-shadow hover:shadow-xl"
                        >
                            <div className="relative aspect-[4/3] overflow-hidden bg-black/5">
                                <SafeImage src={p.image} alt={p.name} className="transition-transform duration-700 group-hover:scale-[1.06]" />
                                <span className="absolute left-4 top-4 inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-[11px] font-medium text-ink backdrop-blur">
                                    {p.tag}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-6">
                                <div className="flex items-start justify-between gap-3">
                                    <h2 className="font-display text-xl font-bold tracking-tight">
                                        {p.name}
                                    </h2>
                                    <span className="grid h-9 w-9 place-items-center rounded-full bg-ink text-white transition-transform group-hover:scale-110">
                                        <ArrowUpRight className="h-4 w-4" />
                                    </span>
                                </div>
                                <p className="mt-2 text-sm leading-relaxed text-ink-muted">
                                    {p.blurb}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </main>
    );
}
